import { PaymentElement } from '@stripe/react-stripe-js';
import type { StripePaymentElementOptions } from '@stripe/stripe-js';
import { useTranslation } from '@frontend/i18n';
import { TextField } from '@frontend/design-system';
import { usePaymentMethodSetupContext } from '../../../widgets/payment-method-setup/context/payment-method-setup-base.context';
import { usePaymentMethodSetupStripeContext } from '../../../widgets/payment-method-setup/context/payment-method-setup-stripe.context';

const PAYMENT_ELEMENT_OPTIONS: StripePaymentElementOptions = {
  wallets: { applePay: 'never', googlePay: 'never' },
};

/** Same fields as the Weave app's add-card form (`CardOnFileFormStripe`). */
export const PaymentMethodSetupFormStripe = () => {
  const { t } = useTranslation('payments');
  const { kind } = usePaymentMethodSetupContext();
  const { nameFieldProps, onElementChange, onElementReady, onElementLoadError } = usePaymentMethodSetupStripeContext();

  return (
    <>
      {kind === 'card' && (
        <TextField name='cardholderName' label={t('Cardholder Name')} hasNonFloatingLabel {...nameFieldProps} />
      )}
      <PaymentElement
        options={PAYMENT_ELEMENT_OPTIONS}
        onChange={onElementChange}
        onReady={onElementReady}
        onLoadError={onElementLoadError}
      />
    </>
  );
};
